import { render, staticRenderFns } from "./release.vue?vue&type=template&id=c4af4a04&scoped=true"
import script from "./release.vue?vue&type=script&lang=js"
export * from "./release.vue?vue&type=script&lang=js"
import style0 from "./release.vue?vue&type=style&index=0&id=c4af4a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4af4a04",
  null
  
)

export default component.exports